import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQbrPeriodOptions = createSelector(
  [selectQbrState],
  ({ documentSettings }) => documentSettings.periodOptions
)
